import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { ContentCard } from '../components/ContentCard';
import { IdCardIcon, EyeIcon, SunIcon, UsersIcon, FootprintsIcon, SplitIcon, ParkingCircleIcon } from 'lucide-react';
const laws = [{
  icon: IdCardIcon,
  title: 'Motorcycle Endorsement Required',
  description: "You must have a motorcycle endorsement (CY) on your Michigan driver's license to legally operate a motorcycle on public roads.",
  variant: 'important' as const
}, {
  icon: EyeIcon,
  title: 'Eye Protection Required',
  description: "If your motorcycle doesn't have a windscreen, you must wear eye protection (glasses, goggles, or face shield) while riding.",
  variant: 'default' as const
}, {
  icon: SunIcon,
  title: 'Headlight Always On',
  description: 'Your motorcycle headlight must be on at all times while operating, day or night. This is a safety requirement.',
  variant: 'default' as const
}, {
  icon: UsersIcon,
  title: 'Two Riders Maximum',
  description: 'No more than two people can ride on a motorcycle at any time. The bike must be designed to carry a passenger.',
  variant: 'default' as const
}, {
  icon: FootprintsIcon,
  title: 'Passenger Footrests Required',
  description: 'If carrying a passenger, your motorcycle must have footrests for the passenger. Operating without them is illegal.',
  variant: 'default' as const
}, {
  icon: SplitIcon,
  title: 'Lane Sharing Prohibited',
  description: 'Sharing a lane with cars or other vehicles is illegal in Michigan. Each motorcycle must have its own full lane.',
  variant: 'warning' as const
}, {
  icon: ParkingCircleIcon,
  title: 'Designated Parking Only',
  description: 'Motorcycles must use designated parking spaces. Parking on sidewalks or between cars is prohibited in most areas.',
  variant: 'default' as const
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function MotorcycleLaws() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-302">
      <PageHeader title="MI Motorcycle Laws" subtitle="General regulations for Michigan riders" data-id="element-303" />

      <main className="px-4 py-6" data-id="element-304">
        <motion.div className="space-y-3" variants={container} initial="hidden" animate="show" data-id="element-305">
          {laws.map((law, index) => <motion.div key={index} variants={item} data-id="element-306">
              <ContentCard icon={law.icon} title={law.title} description={law.description} variant={law.variant} data-id="element-307" />
            </motion.div>)}
        </motion.div>

        {/* Endorsement Info */}
        <motion.div className="mt-6 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-308">
          <p className="text-[#d4a853] font-semibold mb-2" data-id="element-309">
            Getting Your Endorsement
          </p>
          <p className="text-[#a3a3a3] text-sm mb-3" data-id="element-310">
            To get a motorcycle endorsement in Michigan, you must pass both a
            written knowledge test and a skills test, or complete an approved
            motorcycle safety course.
          </p>
          <p className="text-[#a3a3a3] text-xs" data-id="element-311">
            Visit Michigan SOS for more information on testing locations.
          </p>
        </motion.div>
      </main>
    </div>;
}